module.exports = __webpack_public_path__ + "img/IMG-20200902-WA0003.3b1d3446.jpg";